import React from 'react';
import { LogOut } from 'lucide-react';
import { Button } from '../components/ui/button';
import { PaymentFormStripe } from '../components/PaymentFormStripe';
interface SubscribeRequiredProps {
  onSignOut: () => void;
  onSubscriptionSuccess?: () => void;
}

/**
 * Full-screen gate shown when the user's free trial has expired and they have no subscription.
 * User cannot access the app until they subscribe. Includes support contact for errors.
 */
export default function SubscribeRequired({ onSignOut, onSubscriptionSuccess }: SubscribeRequiredProps) {
  return (
    <div className="min-h-screen bg-gradient-to-br from-background via-background to-primary/5 flex flex-col">
      {/* Minimal header: logo + sign out only */}
      <header className="border-b bg-card/50 backdrop-blur-sm">
        <div className="container flex items-center justify-between h-14 px-4">
          <div className="flex items-center gap-2">
            <img
              src="/logos/pink_dolphin_logo.png"
              alt="Pink Dolphin logo"
              className="h-6 w-6 object-contain"
            />
            <span className="font-semibold text-foreground">Pink Dolphin Tracker</span>
          </div>
          <Button variant="ghost" size="sm" onClick={onSignOut} className="gap-2">
            <LogOut className="h-4 w-4" />
            Sign out
          </Button>
        </div>
      </header>

      <main className="flex-1 flex flex-col items-center justify-center px-4 py-8 container max-w-lg mx-auto">
        <div className="text-center mb-8">
          <h1 className="text-2xl md:text-3xl font-bold text-foreground mb-2">
            Your free trial has ended
          </h1>
          <p className="text-muted-foreground">
            Subscribe to continue using Pink Dolphin Trading Card Tracker.
          </p>
        </div>

        <div className="w-full rounded-xl border bg-card p-6 shadow-sm">
          <PaymentFormStripe
            trialExpired
            onSuccess={onSubscriptionSuccess}
          />
        </div>

        <p className="mt-8 text-sm text-muted-foreground text-center max-w-md">
          If you think there has been an error, please reach out to{' '}
          <a
            href="mailto:support@pinkdolphincards.com"
            className="text-primary underline underline-offset-2 hover:no-underline"
          >
            support@pinkdolphincards.com
          </a>
          .
        </p>
      </main>
    </div>
  );
}
